import { base } from "./flux/base"
import { extranet } from "./flux/extranet"

export const Fluxs = { base, extranet }
export type Flux = keyof typeof Fluxs

